import { FormTextArea } from "components/fields/FormTextArea";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface InformationProps {
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value: string | null;
  originalDescription: string | null;
  isRegenerateSuggestions: boolean;
  onRegenerateChange: (checked: boolean) => void;
}

const Information = ({ 
  onChange, 
  value, 
  originalDescription,
  isRegenerateSuggestions,
  onRegenerateChange
}: InformationProps) => {
  const { t } = useTranslation();
  const isDescriptionChanged = value !== originalDescription;
  const showCheckbox = isDescriptionChanged;

  return (
    <div className="flex flex-col gap-3">
      <FormTextArea
        label={t("agents.description")}
        placeholder={t("agents.descriptionPlaceholder")}
        id="description"
        name="description"
        cols={30}
        rows={7}
        onChange={onChange}
        value={value || ""}
      />
      {showCheckbox && (
        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            className="h-4 w-4 accent-brand-500"
            checked={isRegenerateSuggestions}
            onChange={(e) => onRegenerateChange(e.target.checked)}
          />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {t("agents.regenerateSuggestions")}
          </span>
        </label>
      )}
    </div>
  );
};

export default Information;
